import { FunctionComponent } from 'react';
import { CPSuccessModal } from 'widgets/auth/createPassword/SuccessModal';

export const CreatePasswordSuccess: FunctionComponent = () => {
	return <CPSuccessModal />;
};
